import { googleLogout } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "../utils/axios";
import useAuth from "./useAuth";

const useLogout = () => {
  const { setCurrentUser } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    setCurrentUser({});
    googleLogout();
    try {
      await axios.post("/userLogout", {}, { withCredentials: true });
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return logout;
};

export default useLogout;
